// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"75618a44","545":"d7b13312","787":"33f50dfd"}[chunkId] + ".chunk.js";
};